import { render, staticRenderFns } from "./collegeIntro.vue?vue&type=template&id=744b9eed&scoped=true"
import script from "./collegeIntro.vue?vue&type=script&lang=js"
export * from "./collegeIntro.vue?vue&type=script&lang=js"
import style0 from "./collegeIntro.vue?vue&type=style&index=0&id=744b9eed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b9eed",
  null
  
)

export default component.exports